import * as STD from '@emersya/mpa-std';
import * as CM from '@emersya/mpa-components-manager';

export interface IMenuContextualComponentConfiguration extends IMenuComponentConfiguration {
};

export class MenuContextualComponent extends MenuComponent<
	HTMLMenuElement,
	MenuContextualComponent,
	IMenuContextualComponentConfiguration
> {
	setPosition(pos: { x: number; y: number }) {
		const p = {
			x: pos.x,
			y: pos.y
		};
		const o = {
			x: 0,//(<any>this.DOM.offsetParent).offsetLeft,
			y: 0,//(<any>this.DOM.offsetParent).offsetTop
		};
		const s = {
			x: this.component_DOM.offsetWidth,
			y: this.component_DOM.offsetHeight
		};
		const max = {
			x: CM.Manager.root.component_DOM.offsetWidth,
			y: CM.Manager.root.component_DOM.offsetHeight
		};
		if ((o.x + p.x + s.x) > max.x) {
			p.x = max.x - (o.x + s.x);
		}
		if ((o.y + p.y + s.y) > max.y) {
			p.y = max.y - (o.y + s.y);
		}
		p.x = Math.round(p.x);
		p.y = Math.round(p.y);
		if (p.x < 0) {
			p.x = 0;
		}
		if (p.y < 0) {
			p.y = 0;
		}
		this.component_stylize({
			left: p.x + 'px',
			top: p.y + 'px'
		}, 'self');
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IMenuContextualComponentConfiguration
	) {
		super(descriptor, configuration);
		this.component_DOM = <HTMLMenuElement>STD.DOM.factory({tag: 'menu'});
	};
};
export namespace NS {
	export const Component = MenuContextualComponent;
	export type Component = MenuContextualComponent;
	export type Configuration = IMenuContextualComponentConfiguration;
}
import './MenuContextual.scss';
import {MenuComponent, IMenuComponentConfiguration} from '../Menu/Menu';

CM.Manager.declare({
	id: 'menu-contextual',
	type: MenuContextualComponent,
});
